"use strict";
exports.__esModule = true;
var floor_1 = require("./floor");
var getRandomInt = function (min, max) {
    return (0, floor_1["default"])(Math.random() * (max + 1 - min) + min);
};
exports["default"] = getRandomInt;
